import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';

createApp(App).mount('#app')
